import { render, staticRenderFns } from "./DetailMemberPiutangComponent.vue?vue&type=template&id=33d1ee39"
import script from "./DetailMemberPiutangComponent.vue?vue&type=script&lang=js"
export * from "./DetailMemberPiutangComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports